import type {
  AxiosRequestConfig,
  DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

interface SendOTPRequestBody {
  phone_number: string;
}

export interface SendOTPResponse {}

export const RequestOTPFn = async (
  body: SendOTPRequestBody,
  config: AxiosRequestConfig = {}
): Promise<SendOTPResponse> => {
  // Sử dụng Next.js API route làm proxy để bảo vệ endpoint
  const response = await fetch('/api/auth/request-otp', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({
      error: 'NETWORK_ERROR',
      message: 'Không thể kết nối đến server',
    }));

    // Tạo error object tương thích với axios format
    const error: any = new Error(errorData.message || 'Failed to request OTP');
    error.response = {
      data: errorData, // Giữ nguyên toàn bộ errorData để có đầy đủ title, description, etc.
      status: response.status,
    };
    throw error;
  }

  return response.json();
};

export const useRequestOTP = (
  opts?: UseMutationOptions<
    SendOTPResponse,
    DefaultQueryError,
    SendOTPRequestBody
  >
) => {
  return useMutation<SendOTPResponse, DefaultQueryError, SendOTPRequestBody>({
    mutationFn: RequestOTPFn,
    ...opts,
  });
};
